import service from '@/store/services/finance/click/click-service';

const state = {
  list: {},
  meta: {},
  click: {},
  data_export: null,
};

const mutations = {
  SET_RESOURCE: (state, click) => {
    state.click = click;
  },
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_DATA_EXPORT: (state, data_export) => {
    state.data_export = data_export;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params)
      .then(({ list, meta }) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  getDataFilterDate({ commit }, params) {
    commit('SET_DATA_EXPORT', null);
    return service.filterExportLi(params).then(({ list }) => {
      let containerData = [];
      for (let i = 0; i < list.length; i++) {
        const r = list[i];
        let parsing = new DOMParser();
        let xmlDom = parsing.parseFromString(r.xml_data, "text/xml");
        const ApplicationCode = xmlDom.getElementsByTagName("cb:ApplicationCodes")[0];
        const ProviderApplicationNo = ApplicationCode.attributes?.ProviderApplicationNo?.value ?? ''

        let data = {
          no: containerData.length + 1,
          nama: r.NameAsId,
          customer_id: r.IdentityNumber,
          provider_app_no: ProviderApplicationNo,
          time_stamp: '',
          reff_number: r.IdMessage,
          enq_date: r.created_at,
        }

        containerData.push(data);
      }

      commit('SET_DATA_EXPORT', containerData);
    })
  },

  postNewApplication({ commit, dispatch }, params) {
    return service.postNewApplication(params, true)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

  postNewApplicationB2b({ commit, dispatch }, params) {
    return service.postNewApplicationB2b(params, true)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

  getNewApplication({ commit, dispatch }, params) {
    return service.postNewApplication(params, false)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

  postMonitoringBySubject({ commit, dispatch }, params) {
    return service.postMonitoringBySubject(params)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

  postMonitoringBySubjectCode({ commit, dispatch }, params) {
    return service.postMonitoringBySubjectCode(params)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

  gepostPortfolioEnqt({ commit, dispatch }, params) {
    return service.postPortfolioEnq(params)
      .then((click) => { commit('SET_RESOURCE', click); });
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  click: state => state.click,
  list_data_export: state => state.data_export,
};

const click = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default click;
